import { Typography } from '@mui/material'

export default function Footer() {
  return (
    <div style={{ width: '80%', textAlign: 'center', margin: '1em auto' }}>
      <Typography variant="body1" style={{ fontFamily: 'GenYOGothic2TW' }}>
        慧智瞳科技版權所有 Copyright © 2025 AIEye Tech All Rights Reserved.
      </Typography>
    </div>
  )
}
